export default __webpack_public_path__ + "static/dge_medium_1-0d4b2e7a130ed29e92125d25c788e415.webp";